import {useState} from 'react'
import Select from 'react-select';

const AddContentModel = ({language, isVisible, setIsVisible}) => {
    const [modelName, setModelName] = useState()
    const [modelType, setModelType] = useState()
    const [modelIcon, setModelIcon] = useState()
    const filter = [{value: 'major', label: 'MA'},{value: 'minor', label: 'MI'}]
    
    
    const selectContentModelType = (option) => {
        setModelType(option.value)
    }

    const handleClose = async e => {
        
        setIsVisible(isVisible ? false : true)
    }

    const postContentModel = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($modelName: String){
                        postContentModel(modelName:$modelName) {
                            id
                        }
                    }`,
            variables: {
                "modelName": modelName
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            
            return 
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const handleSelectIcon = (selectedIcon) => {
        setModelIcon(selectedIcon)
    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(modelName === ""){
            error = true
        }
        if(!error){
            await postContentModel()
        }
    }

    return (
        <>
        {(isVisible) && <div id="cc_overlay"></div>}
        <div id="cc_editarticle" className={isVisible ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Tilføj nyt Indhold' : 'Add new Content'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>Type</span>
                        <Select className="contentModelSelect" classNamePrefix="contentModelSelect" options={filter} onChange={selectContentModelType} placeholder={language.value === 'DA' ? 'Indholds type' : 'Content type'} />
                    </label>
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="contentTypeName" value={modelName} onChange={ e => setModelName(e.target.value)} autoComplete="off"/>
                    </label>
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Ikon' : 'Icon'}</span>
                        <div className="cc-model-icon-container">
                            <span className={`cc-model-icon ${(modelIcon === 'document') && 'selected'}`}><i className="sprite-icon icon-document" onClick={()=>handleSelectIcon('document')}></i></span>
                            <span className={`cc-model-icon ${(modelIcon === 'menu') && 'selected'}`}><i className="sprite-icon icon-menu" onClick={()=>handleSelectIcon('menu')}></i></span>
                        </div>
                    </label>
                </div>
                
                <div className="align_right">
                    <button onClick={handleSave} className="cc-btn blue-gradient">{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default AddContentModel
